import { css, cx } from 'linaria';
import { cssTheme } from '@uds/theme-utils';

import { DomainSearchSuggestionsDesignProps } from './DomainSearchSuggestions';

const root = css`
  width: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: ${cssTheme.gu1};
  padding-top: ${cssTheme.gu1};
  padding-bottom: ${cssTheme.gu1};

  ${cssTheme.breakpoints.lg} {
    gap: ${cssTheme.gu2};
  }
`;

const collapsePaddingTop = css`
  &&& {
    padding-top: ${cssTheme.gu4};

    ${cssTheme.breakpoints.sm} {
      padding-top: ${cssTheme.gu5};
    }

    ${cssTheme.breakpoints.lg} {
      padding-top: ${cssTheme.gu6};
    }
  }
`;

const collapsePaddingBottom = css`
  &&& {
    padding-bottom: ${cssTheme.gu4};

    ${cssTheme.breakpoints.sm} {
      padding-bottom: ${cssTheme.gu5};
    }

    ${cssTheme.breakpoints.lg} {
      padding-bottom: ${cssTheme.gu6};
    }
  }
`;

const list = css`
  list-style-type: none;
  display: flex;
  flex-direction: column;
  gap: ${cssTheme.gu1};
  padding: 0;
  margin-bottom: 0;
  ${cssTheme.breakpoints.lg} {
    gap: ${cssTheme.gu2};
  }
`;

const intro = css`
  padding: ${cssTheme.gu3};
  display: flex;
  flex-direction: column;
  gap: ${cssTheme.gu3};

  ${cssTheme.breakpoints.md} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const getClassNames = ({ design }: { design: DomainSearchSuggestionsDesignProps }) => ({
  list,
  intro,
  root: cx(
    root,
    design?.collapsePadding?.top === false && collapsePaddingTop,
    design?.collapsePadding?.bottom === false && collapsePaddingBottom,
  ),
});
